import { Injectable } from '@angular/core';
import { HttpClient, HttpHeaders } from '@angular/common/http';
import { Router } from '@angular/router';
import swal from 'sweetalert2';
import { Observable } from 'rxjs';
import { UiService } from '../ui/ui.service';
import { environment } from '../../../environments/environment';
import { finalize } from 'rxjs/operators';

import 'rxjs/add/operator/concatMap';
import 'rxjs/add/operator/map';

export enum UserType {
  ADMIN = 2,
  ALUMNI,
  TEACHER,
  STUDENT
};

@Injectable()
export class UserService {

  public info = null;
  public logo = null;

  constructor(
    private http: HttpClient,
    private router: Router,
    private ui: UiService
  ) { }

  get role() {
    if (this.info) {
      switch (this.info.type) {
        case '1': return 'super-admin';
        case '2': return 'admin';
        case '3': return 'alumni';
        case '4': return 'teacher';
        case '5': return 'student';
      }
    }
    return '';
  }

  get logoUrl() {
    return this.logo;
  }

  set logoUrl(url) {
    this.logo = url;
  }

  getLogo(payload, callback) {
    this.http.get('/bmi-others/logo?branchId=' + payload).subscribe(
      (res: any) => {
        if (!res.length) {
          this.logoUrl = environment.apiUrl + '/' + res.file.path + '/' + res.file.enc_name + '.' + res.file.extension;
        }
        callback(res);
      },
      (err) => {
        callback(err);
      }
    );
  }

  loggedIn() {
    return Observable.create(obs => {
      const token = localStorage.getItem('access_token');
      if (token) {
        if (this.info) {
          obs.next(true);
          return;
        }
        this.ui.loader.show('user.service.ts => loggedIn');
        this.http.get('/user/me')
          .concatMap(res1 => this.http.get('/auth/me').map(res2 => [res1, res2]))
          .subscribe(
            (res: any) => {
              this.ui.loader.hide('user.service.ts => loggedIn');
              if (res[0].type != UserType.TEACHER) {
                obs.next(false);
                localStorage.removeItem('access_token');
              } else {
                this.info = res[0];
                if (res[1] && res[1].access_token) {
                  localStorage.setItem('access_token', res[1].access_token);
                }
                obs.next(true);
              }
            },
            err => {
              this.ui.loader.hide('user.service.ts => loggedIn');
              obs.next(false);
              localStorage.removeItem('access_token');
            }
          );
      } else {
        obs.next(false);
      }
    });
  }

  login(user_credentials, callback) {
    const payload = {
      ...user_credentials,
      type: UserType.TEACHER + ''
    }
    this.http.post('/auth/login', payload).subscribe(
      (res: any) => {
        // localStorage.setItem('access_token', res.access_token);
        callback(null, res)
      },
      err => {
        callback(err);
      }
    )
  }

  signup(email, type, callback) {
    const payload = {
      email, type,
      link: environment.baseUrl + '/signup/complete/',
      gdpr_acceptance: 'A'
    };
    this.http.post('/auth/register', payload).subscribe(
      res => {
        callback(null, res);
      },
      err => {
        callback(err)
      }
    );
  }

  logout() {
    this.ui.loader.show();
    this.http.post('/auth/logout', {})
      .pipe(
        finalize(() => this.ui.loader.hide())
      )
      .subscribe(
        res => {
          this.info = null;
          localStorage.removeItem('access_token');
          this.router.navigate(['login']);
        },
        err => {
          this.info = null;
          localStorage.removeItem('access_token');
          this.router.navigate(['login']);
        }
      );
  }

  getUserDetails() {
    if (this.loggedIn) {

    }
  }

  uploadProfileImage(file, callback) {
    const formData = new FormData();
    formData.append('img', file);
    let headers = new HttpHeaders();
    headers = headers.set('no-content-type', 'true');
    this.http.post('/user/profile-pic', formData, { headers }).subscribe(
      (res: any) => {
        this.info.image = res.file.name;
        console.log(this.info.image);
        callback(null, res);
      },
      err => {
        callback(err);
      }
    );
  }

  updateProfile(payload, callback) {
    this.http.put('/user', payload).subscribe(
      (res: any) => {
        this.info = res.user;
        callback(null, res);
      },
      err => {
        callback(err);
      }
    );
  }

  changePassword(userId, payload, callback) {
    this.http.put('/all/password/' + userId, payload).subscribe(
      res => {
        callback(null, res);
      },
      callback
    );
  }

  changeMyPassword(payload, callback) {
    this.http.put('/my/password', payload).subscribe(
      res => {
        callback(null, res);
      },
      callback
    );
  }

  changeProfileImage(payload, type, callback) {
    const formData = new FormData();
    for (let key in payload) {
      formData.append(key, payload[key]);
    }
    let headers = new HttpHeaders();
    headers = headers.set('no-content-type', 'true');
    this.http.post(
      '/' + type + (type === 'teacher' ? '/pic' : ''), formData, { headers }
    ).subscribe(
      (res: any) => {
        callback(null, res);
      },
      err => {
        callback(err);
      }
    );
  }

  updateProfileByType(type, payload, user_id, callback) {
    this.http.put('/' + type + '/' + user_id, payload).subscribe(
      res => {
        callback(null, res);
      },
      err => {
        callback(err);
      }
    );
  }

  deleteProfile(user_id, callback) {
    this.http.delete('/destroy/user/' + user_id).subscribe(
      res => callback(null, res),
      err => callback(err)
    );
  }

}



// WEBPACK FOOTER //
// G:/UTL/Teacher/Teacher-ANG/src/app/services/user/user.service.ts